import { render, staticRenderFns } from "./CardDentistaSelecionado.vue?vue&type=template&id=20cdb0e0&scoped=true"
import script from "./CardDentistaSelecionado.vue?vue&type=script&lang=js"
export * from "./CardDentistaSelecionado.vue?vue&type=script&lang=js"
import style0 from "./CardDentistaSelecionado.vue?vue&type=style&index=0&id=20cdb0e0&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20cdb0e0",
  null
  
)

export default component.exports